<template>
  <v-select
    ref="selectedEl"
    v-model="selected"
    item-value="id"
    item-text="name"
    return-object
    single-line
    :items="languages"
    :label="$t('BUTTON.EXPORT')"
    @change="getPdf"
  >
  </v-select>
</template>

<script>
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'ExportLanguageSelect',

  data: () => ({
    languages: [],
    selected: null
  }),

  created() {
    this.retrieveLanguages().then(response => {
      this.languages = response.data;
    });
  },

  methods: {
    ...mapCacheActions('localization', ['retrieveLanguages']),
    getPdf(v) {
      this.$emit('getPdf', v);
      this.$refs['selectedEl'].reset();
    }
  }
};
</script>

<style scoped></style>
